import React from "react";
import tw from "twin.macro";
import { Link } from "gatsby";

import SocialMedia from "./SocialMedia";

const Wrapper = tw.div`grid-cols-1 grid justify-center items-center pt-24 gap-24`;
const Top = tw.div`flex justify-center items-center `;

const A = tw(
  Link
)`text-primary ml-2 transition-colors duration-500 ease-in-out inline-block hover:text-white`;

const Copyright = () => {
  return (
    <Wrapper>
      <Top>
        <h3 tw="font-gothic uppercase flex flex-row items-center mr-2 text-2xl leading-none after:(content[''] bg-white w-6 h-0.5 ml-4)">
          Follow Us
        </h3>
        <SocialMedia />
      </Top>
      <small tw="text-center font-bold text-white text-sm pb-8">
        &copy; {new Date().getFullYear()} Baldwin Matzus. All Rights Reserved.
        <A to="/disclaimer/">Disclaimer.</A>
        <A to="/sitemap/">Site Map.</A>
      </small>
    </Wrapper>
  );
};

export default Copyright;
